module.exports = __webpack_public_path__ + "assets/apoly-logo-white-no-claim.90760c0b.png";